var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "button-collapse") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "button-collapse",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chevrons-left",
    transform: "translate(2.000000, 3.000000)",
    stroke: "#666666",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "4.16666667 8.33333333 0 4.16666667 4.16666667 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "10 8.33333333 5.83333333 4.16666667 10 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonCollapse);
export default __webpack_public_path__ + "static/media/button-collapse.66851fa1b761bb3515c5601a37ca3a46.svg";
export { ForwardRef as ReactComponent };